import { useTranslation } from 'react-i18next';
import {
  useGetCustomerPortalUrl,
  useGetProductType,
} from '@legacy/apis/indexAPI';
import { useGetShowSignUpButton } from '@legacy/apis/userSettingsAPI';
import { useGetCurrentPageIdentifier } from '@legacy/stores/PageStore/pageStore.zustand';
import { useVerifyDesignSevenPage } from '@legacy/apis/pagesAPI/designSevenAPI';
import { Button } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import styles from './SignUpButton.module.scss';
import { tlpOrigin } from '@/utils/gateway';

const onSignUpButtonClick = () => {
  const iframe = document.getElementById(
    'timelog-legacy-page-iframe',
  ) as HTMLIFrameElement;

  iframe?.contentWindow?.postMessage(
    { eventId: 'signUpButtonClicked' },
    tlpOrigin(),
  );
};

export const dataAutomationButtonId = 'HeaderSignUpButton';
export const dataAutomationLinkId = 'HeaderSignUpLink';

export const SignUpButton = () => {
  const { t } = useTranslation('header');
  const currentPageIdentifier = useGetCurrentPageIdentifier();
  const { productType } = useGetProductType();
  const {
    isDesignSeven,
    isLoading: isLoadingIsDesignSeven,
    isError: isErrorIsDesignSeven,
  } = useVerifyDesignSevenPage(currentPageIdentifier);

  const {
    showSignUpButton,
    isLoading: isLoadingShowSignUpButton,
    isError: isErrorShowSignUpButton,
  } = useGetShowSignUpButton();

  const {
    customerPortalUrl,
    isLoading: isLoadingCustomerPortalUrl,
    isError: isErrorCustomerPortalUrl,
  } = useGetCustomerPortalUrl();

  const buttonText =
    productType === 'Time' ? t('TimeProductSignUpButton') : t('SignUpButton');
  const hasCustomerPortal =
    customerPortalUrl !== null &&
    customerPortalUrl !== '' &&
    customerPortalUrl !== undefined;
  const isNewPageAndDoNotUseCustomerPortal =
    !hasCustomerPortal && isDesignSeven;
  const isLegacyPageAndLetTLPDecideWhatToDo = !isDesignSeven;
  // This means no tracking as we only have that in TLP
  const isNewPageAndUseCustomerPortal = hasCustomerPortal && isDesignSeven;

  if (
    isLoadingShowSignUpButton ||
    isErrorShowSignUpButton ||
    isLoadingCustomerPortalUrl ||
    isErrorCustomerPortalUrl ||
    isLoadingIsDesignSeven ||
    isErrorIsDesignSeven
  ) {
    return null;
  }

  return showSignUpButton && !isNewPageAndDoNotUseCustomerPortal ? (
    <div className={styles.BuyTimeLogButton}>
      {isNewPageAndUseCustomerPortal && (
        <Button
          href={`${customerPortalUrl}/signup`}
          target="_blank"
          rel="noreferrer"
          size="small"
          data-automation-id={dataAutomationLinkId}
          startIcon={<OpenInNew fill="#fff" />}
          variant="contained"
        >
          {buttonText}
        </Button>
      )}
      {isLegacyPageAndLetTLPDecideWhatToDo && (
        <Button
          size="small"
          data-automation-id={dataAutomationButtonId}
          variant="contained"
          onClick={onSignUpButtonClick}
        >
          {buttonText}
        </Button>
      )}
    </div>
  ) : null;
};
